export const DEFAULT_LIST_PAGE_SIZE = 20;
export function parseOffset(param) {
    if (!param) {
        return 0;
    }
    const n = typeof param === 'number' ? param : parseInt(String(param), 10);
    if (!Number.isFinite(n) || n < 0) {
        return 0;
    }
    return Math.floor(n);
}
export function parseLimit(param, defaultLimit = DEFAULT_LIST_PAGE_SIZE) {
    if (!param) {
        return defaultLimit;
    }
    const n = typeof param === 'number' ? param : parseInt(String(param), 10);
    if (!Number.isFinite(n) || n < 1) {
        return defaultLimit;
    }
    return Math.floor(n);
}
export function pageNoFromOffset(offset, limit = DEFAULT_LIST_PAGE_SIZE) {
    const safeLimit = parseLimit(limit);
    return Math.floor(parseOffset(offset) / safeLimit) + 1;
}
export function offsetFromPageNo(pageNo, limit = DEFAULT_LIST_PAGE_SIZE) {
    const safePage = Math.max(1, Math.floor(pageNo));
    return (safePage - 1) * parseLimit(limit);
}
export function listPageCount(totalCount, pageSize = DEFAULT_LIST_PAGE_SIZE) {
    if (totalCount <= 0) {
        return 1;
    }
    return Math.max(1, Math.ceil(totalCount / pageSize));
}
export function hasListPageAfter(offset, totalCount, limit = DEFAULT_LIST_PAGE_SIZE) {
    return parseOffset(offset) + parseLimit(limit) < totalCount;
}
